import axios, { CancelTokenSource } from 'axios';
import { useState, useEffect, useRef } from 'react';
import { AlarmsService } from 'src/services/alarms';

type UseAlarmTotalCountForSiteParams = {
  customerId: string | null;
  filters: any;
};

export const useGetAlarmTotalCountForSite = ({
  customerId,
  filters,
}: UseAlarmTotalCountForSiteParams) => {
  const [alarmCount, setAlarmCount] = useState({ total: 0 });
  const [isLoaded, setIsLoaded] = useState(false);

  const cancelTokenSourceRef = useRef<CancelTokenSource | null>(null);

  useEffect(() => {
    const getCount = async () => {
      if (!customerId) return;

      if (cancelTokenSourceRef.current) {
        cancelTokenSourceRef.current.cancel('Request canceled.');
      }

      const cancelTokenSource = axios.CancelToken.source();
      cancelTokenSourceRef.current = cancelTokenSource;

      setIsLoaded(false);

      try {
        const result = await AlarmsService.getFilteredAlarmCount(
          customerId,
          undefined,
          undefined,
          filters,
          cancelTokenSource.token
        );
        setAlarmCount(result);
      } catch (error) {
        console.error(error);
        setAlarmCount({ total: 0 });
      } finally {
        setIsLoaded(true);
      }
    };

    getCount();

    return () => {
      if (cancelTokenSourceRef.current) {
        cancelTokenSourceRef.current.cancel('Filters changed.');
      }
    };
  }, [customerId, filters]);

  return { alarmCount, isLoaded };
};
